export const passwordValidationRegex = /^[a-zA-Z0-9+~!@#%&()_=\-^]*$/;
export enum AlertLevel {
  ALERT = 'alert',
  INFORMATION = 'information',
  SUCCESS = 'success',
  ERROR = 'error',
}
